import { RecurringTransactionDetailsTab } from "./RecurringTransactionDetailsTab";
import { RecurringTransactionContactDisplay } from "./RecurringTransactionContactDisplay";
import { RecurringTransactionCompanyDisplay } from "./RecurringTransactionCompanyDisplay";
import { RecurringTransactionQuickBooksDisplay } from "./RecurringTransactionQuickBooksDisplay";

export { RecurringTransactionDetailsTab } from "./RecurringTransactionDetailsTab";
export { RecurringTransactionContactDisplay } from "./RecurringTransactionContactDisplay";
export { RecurringTransactionCompanyDisplay } from "./RecurringTransactionCompanyDisplay";
export { RecurringTransactionQuickBooksDisplay } from "./RecurringTransactionQuickBooksDisplay";

export const RecurringTransactionDetailTabComponents = {
  RecurringTransactionDetailsTab,
  RecurringTransactionContactDisplay,
  RecurringTransactionCompanyDisplay,
  RecurringTransactionQuickBooksDisplay,
};
